import { Injectable } from '@angular/core';
import {
  IOnboardingParams,
  IOnboardingParamsWithoutFormat,
} from '../../../core/models/onboarding.model';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor() {}

  public buildCustomerInfo(stepInfo: IOnboardingParamsWithoutFormat): IOnboardingParams {
    const {
      first_name,
      middle_name,
      first_surname,
      second_surname,
      identification_number,
      identification_expedition_at,
      occupation,
      email,
      email_confirmation,
      civil_status,
      spouse_name,
      spouse_surname,
      accept_processing_of_personal_data,
      accept_personal_data_for_commercial_purposes,
    } = stepInfo || {};
    const formatted_identification_expedition_at = new Date(
      identification_expedition_at + 'T00:00:00'
    );
    return {
      firstName: first_name,
      middleName: middle_name,
      firstSurname: first_surname,
      secondSurname: second_surname,
      identificationNumber: identification_number,
      identificationExpeditionAt: formatted_identification_expedition_at,
      occupation: occupation,
      email,
      emailConfirmation: email_confirmation,
      civilStatus: civil_status,
      spouseName: spouse_name,
      spouseSurname: spouse_surname,
      acceptProcessingOfPersonalData: accept_processing_of_personal_data,
      acceptPersonalDataForCommercialPurposes: accept_personal_data_for_commercial_purposes,
    };
  }
}
